import * as icons from 'assets/icons/groove'

import CustomFieldEditForm from './CustomFieldEditForm'
import CustomFieldEditValue from './CustomFieldEditValue'
import WidgetCardModal from './WidgetCardModal'

export default function CustomFieldEditModal({
  customFieldKey,
  customFieldIcon,
  customFieldName,
  customFieldType,
  customFieldValue,
  menuRef,
  offset,
  onCancel,
  onSave,
}) {
  const KeyIcon = icons[customFieldIcon]

  return (
    <WidgetCardModal
      foo="bar"
      noCurtain={false}
      onBackgroundClick={onCancel}
      offset={offset}
      ref={menuRef}
    >
      <div className="title">
        {KeyIcon && <KeyIcon className="icon" />}
        <div className="titleValue">{customFieldName}</div>
      </div>
      <CustomFieldEditForm onCancel={onCancel} onSave={onSave}>
        <CustomFieldEditValue
          customFieldKey={customFieldKey}
          customFieldType={customFieldType}
          customFieldValue={customFieldValue}
        />
      </CustomFieldEditForm>
    </WidgetCardModal>
  )
}
